// import { LogImage } from "@assets/constant/index.constant";
// import { maskEmail } from "@utils/helper/index.helper";
// import { useResetPassword } from "@utils/states/index.state";
// import Cookies from "js-cookie";
// import React from "react";
// import { useLocation, useNavigate } from "react-router";

// type Props = { children: React.ReactNode };

// const index: React.FC<Props> = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const isLoginScreen = ["/login"].includes(location.pathname) ? true : false;
//   const { email } = useResetPassword();

//   const getContent = () => {
//     switch (location.pathname) {
//       case "/login":
//         return {
//           title: `Login to your account`,
//           description: `Enter your details to access your account`,
//         };
//       case "/forget-password":
//         return {
//           title: `Forgot password`,
//           description: `Enter your registered email and we'll send you a verification code to reset your password.`,
//         };
//       case "/reset-verify-otp":
//         return {
//           title: `Reset your password`,
//           description: `We've sent 6 digit OTP code on your email address ${maskEmail(
//             email
//           )}.`,
//         };

//       case "/reset-password":
//         return {
//           title: `Reset your password`,
//           description: ``,
//         };

//       default:
//         break;
//     }
//   };
//   if((Cookies.get("access")||sessionStorage.getItem("access"))) return navigate('/journey');
//   return (
//     <>
//       <div className="w-full h-[100vh] flex items-center ">
//         {isLoginScreen && (
//           <div className="lg:w-1/2 lg:block h-full hidden">
//             <img
//               src={LogImage}
//               className="h-full rounded-e-[60px]  object-cover"
//             />
//           </div>
//         )}
//         <div
//           className={`${
//             isLoginScreen ? "lg:w-1/2 w-full" : "w-[424px] mx-auto"
//           } flex flex-col items-center justify-center gap-y-[32px]`}
//         >
//           <div className="flex flex-col gap-y-[32px] items-center">
//             <img
//               src="/assets/images/logo.svg"
//               alt="logo"
//               className="select-none  max-w-[191px]"
//             />
//             <div className="text-center">
//               <h1 className="text-[28px] font-[600]">{getContent()?.title}</h1>
//               <p className="text-[#969696]">{getContent()?.description}</p>
//             </div>
//           </div>
//           {children}
//         </div>
//       </div>
//     </>
//   );
// };

// export default index;

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { maskEmail } from "@utils/helper/index.helper";
import { LogImage } from "@assets/constant/index.constant";
import { useResetPassword } from "@utils/states/index.state";

type Props = { children: React.ReactNode };

const Index: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginScreen = ["/login"].includes(location.pathname);
  const { email } = useResetPassword();

  // Move redirect into useEffect
  useEffect(() => {
    if (Cookies.get("access") || sessionStorage.getItem("access")) {
      navigate("/journey");
    }
  }, [navigate]);

  const getContent = () => {
    switch (location.pathname) {
      case "/login":
        return {
          title: `Login to your account`,
          description: `Enter your details to access your account`,
        };
      case "/forget-password":
        return {
          title: `Forgot password`,
          description: `Enter your registered email and we'll send you a verification code to reset your password.`,
        };
      case "/reset-verify-otp":
        return {
          title: `Reset your password`,
          description: `We've sent 6 digit OTP code on your email address ${maskEmail(
            email
          )}.`,
        };
      case "/reset-password":
        return {
          title: `Reset your password`,
          description: ``,
        };
      default:
        return {
          title: "",
          description: "",
        };
    }
  };

  return (
    <div className="w-full h-[100vh] flex items-center">
      {isLoginScreen && (
        <div className="lg:w-1/2 lg:block h-full hidden">
          <img
            src={LogImage}
            className="h-full rounded-e-[60px] object-cover"
            alt=""
          />
        </div>
      )}
      <div
        className={`${
          isLoginScreen ? "lg:w-1/2 w-full" : "w-[424px] mx-auto"
        } flex flex-col items-center justify-center gap-y-[32px]`}
      >
        <div className="flex flex-col gap-y-[32px] items-center">
          <img
            src="/assets/images/logo.svg"
            alt="logo"
            className="select-none max-w-[191px]"
          />
          <div className="text-center max-md:p-4">
            <h1 className="text-[28px] font-[600]">{getContent().title}</h1>
            <p className="text-[#969696]">{getContent().description}</p>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Index;
